import React from 'react';

export default class GraficoPadrao extends React.Component {
    static defaultProps = {
        data: [],
        dataKeyXAxis: "",
        dataKeyLine: "",
        gridColor: "#836BAE",
        lineColor: "#0099FF",
        width: "100%",
        height: 300,
        label: "",
        intro: "Gráfico de linha",
    }
}